import invoiceApproval from '../invoiceApproval';
import {
  faFileInvoiceDollar,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import pendingInvoicesSync from './pendingInvoicesSync';

export default {
  name: 'vendorDashboard',
  components: {
    invoiceApproval,
    faFileInvoiceDollar,
    faArrowRight,
    pendingInvoicesSync
  },
  data() {
    return {
      count1: 0,
      count2: 0,
      count3: 0,
      showCard: false,
      cardName: null,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: true,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false
      }
    };
  },
  mounted() {
    this.getPendingInvSyncCount();
    this.getPendingGrnSyncCount();
    this.getPendingRecDocCount();
  },
  methods: {
    // 1.0 <Anuj> use for show hide card details
    showHideCard(flag, type) {
      this.cardName = null;
      const typeCountMap = {
        pendingInvSync: this.count1,
        pendingGrnSync: this.count2,
        pendingRecDoc: this.count3
      };

      if (type && typeCountMap[type] === 0) {
        this.$bvToast.toast('No records found.', {
          title: 'Alert',
          variant: 'danger',
          solid: true,
          autoHideDelay: 7000
        });
        return;
      }
      this.showCard = flag;
      this.cardName = type;
    },
    // 1.0 <Anuj> To get pending Invoice sync data count
    getPendingInvSyncCount() {
      this.loader = true;
      this.$store
        .dispatch('vendorDashboard/getPendingInvSyncCount')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.count1 = resp.data.data[0].total_pending_count;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // 1.0 <Anuj> To get pending GRN sync data count
    getPendingGrnSyncCount() {
      this.loader = true;
      this.$store
        .dispatch('vendorDashboard/getPendingGrnSyncCount')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.count2 = resp.data.data[0].total_pending_count;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // 1.0 <Anuj> To get pending Receipt document data count
    getPendingRecDocCount() {
      this.loader = true;
      this.$store
        .dispatch('vendorDashboard/getPendingRecDocCount')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.count3 = resp.data.data[0].total_pending_count;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // 1.1 <Anuj> Refresh the count of records
    refreshCount() {
      this.getPendingInvSyncCount();
      this.getPendingGrnSyncCount();
      this.getPendingRecDocCount();
    }
    // getFormattedDates(daysAgo = 3650) {
    //   const formatDate = date => {
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = date.toLocaleString('en-US', { month: 'short' });
    //     const year = date.getFullYear();
    //     return `${day}-${month}-${year}`;
    //   };

    //   const today = new Date();
    //   const pastDate = new Date();
    //   pastDate.setDate(today.getDate() - daysAgo);

    //   return {
    //     currentDate: formatDate(today),
    //     pastDate: formatDate(pastDate)
    //   };
    // }
  }
};
